import { openZipModal } from '@/redux/modules/modal';
import { useAppDispatch } from '@/redux/hooks';
import { useCallback } from 'react';

export const useOpenZipPayModal = () => {
    const dispatch = useAppDispatch();

    return useCallback(async () => {
        dispatch(openZipModal());
    }, [dispatch]);
};
